// extracted by mini-css-extract-plugin
export default {"base":"FileUploadCaption_base__zHz+N","isError":"FileUploadCaption_isError__ZZOd6"};